import React from "react";
import { useDispatch, useSelector } from "react-redux";
import LiveAuctionList from "../updateLiveRoom/LiveAuctionList";
import { getLiveRoomAuctionList } from "../../../../redux/action/liveRoom";
import AllLiveAuctionFrame from "../../../commanPage/liveRoom/AllLiveAuctionFrame";

function BuyerTodayAuctions() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state?.profileStore);
  const { ListLoadings } = useSelector((state) => state.liveAuctionList);

  const handleReload = () => {
    dispatch(getLiveRoomAuctionList(profile?.organization));
  };

  return (
    <AllLiveAuctionFrame
      children={<LiveAuctionList />}
      handleReload={handleReload}
      ListLoadings={ListLoadings}
    />
  );
}

export default BuyerTodayAuctions;
